module.exports = __webpack_public_path__ + "img/image6.6e0c6883.svg";